// extracted by mini-css-extract-plugin
export default {"therapyContent":"therapy_therapyContent__WSALI"};